const React = require('react');
const isNode = (typeof process !== 'undefined');
const Soker = require('./Soker');
const Input = require('./../../FormComponents/Input');
const SelectComponent = require('./../../FormComponents/Select');

const occupationOptions = [
    { value: 'i-arbeid', label: 'I arbeid' },
    { value: 'student', label: 'Student' },
    { value: 'hjemmevaerende-med-barn', label: 'Hjemmeværende med barn' },
    { value: 'arbeidssoker', label: 'Arbeidssøker' },
    { value: 'pensjonist', label: 'Pensjonist' },
    { value: 'hjemmevaerende', label: 'Hjemmeværende' },
];

const maritalStatusOptions = [
    { value: 'Enslig', label: 'Enslig' },
    { value: 'Samboer/gift', label: 'Samboer/gift' }
];

const depositOptions = [
    { value: 'Ja, jeg kan betale 3 måneders depositum', label: 'Ja, jeg kan betale 3 måneders depositum' },
    { value: 'Nei, jeg kan ikke betale 3 måneders depositum', label: 'Nei, jeg kan ikke betale 3 måneders depositum' },
    { value: 'Jeg ønsker leiegaranti', label: 'Jeg ønsker leiegaranti' },
];

const petsOptions = [
    { value: 'Ja, jeg har husdyr', label: 'Ja, jeg har husdyr' },
    { value: 'Nei, jeg har ikke husdyr', label: 'Nei, jeg har ikke husdyr' }
];

const smokeOptions = [
    { value: 'Ja', label: 'Ja' },
    { value: 'Nei', label: 'Nei' },
];

const existingContractOptions = [
    { value: 'Ja', label: 'Ja' },
    { value: 'Nei', label: 'Nei' },
];

const rentalAddressOptions = [
    { value: 'Bjerregaardsgate 17', label: 'Bjerregaardsgate 17' },
    { value: 'Breigata 10', label: 'Breigata 10' },
    { value: 'Harald Hårfagres gate 17', label: 'Harald Hårfagres gate 17' },
    { value: 'Hausmannsgate 19', label: 'Hausmannsgate 19' },
    { value: 'Moerveien 7', label: 'Moerveien 7' },
    { value: 'Moerveien 9', label: 'Moerveien 9' },
    { value: 'Parkveien 62', label: 'Parkveien 62' },
    { value: 'Sagaveien 6', label: 'Sagaveien 6' },
    { value: 'Thereses gate 12', label: 'Thereses gate 12' },
    { value: 'Thorvald Meyersgate 44B', label: 'Thorvald Meyersgate 44B' },
    { value: 'Thorvald Meyersgate 46', label: 'Thorvald Meyersgate 46' },
    { value: 'Trondheimsveien 197 A', label: 'Trondheimsveien 197 A' },
    { value: 'Trondheimsveien 84/86', label: 'Trondheimsveien 84/86' },
    { value: 'Tøyengata 16', label: 'Tøyengata 16' },
    { value: 'Åsaveien 27', label: 'Åsaveien 27' },
    { value: 'Frognerveien 50', label: 'Frognerveien 50' },
    { value: 'Brynsveien 16-18', label: 'Brynsveien 16-18' },
    { value: 'Tollbugata 11', label: 'Tollbugata 11' },
    { value: 'Eilert Sundts gate 52', label: 'Eilert Sundts gate 52' },
    { value: 'Solveien', label: 'Solveien' },
];

const viewingOptions = [
    { value: 'Ja', label: 'Ja' },
    { value: 'Nei', label: 'Nei' },
];

class BoligSoknad extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            occupation: {value: null, label: null},
            existingContract: {value: null, label: null},
            maritalStatus: {value: null, label: null},
            deposit: {value: null, label: null},
            pets: {value: null, label: null},
            rentalAddress: { value: null, label: null },
            hasBeenAtViewing: { value: null, label: null },
        };

        this.setSelectedOption = this.setSelectedOption.bind(this);
    }
    getValues() {
        return {
            rentalAddress: this.state.rentalAddress.label,
            identityNumber: this.identityNumber.value,
            currentAddress: this.currentAddress.value,
            currentZip: this.currentZip.value,
            currentCity: this.currentCity.value,
            maritalStatus: this.state.maritalStatus.label,
            occupation: this.state.occupation.label,
            existingContract: this.state.existingContract.label,
            deposit: this.state.deposit.label,
            pets: this.state.pets.label,
            smoke: this.state.smoke.label,
            numPeople: this.numPeople.value,
            reference: this.reference.value,
            finn: this.finn.value,
            rentFrom: this.rentFrom.value,
            bio: this.bio.value,
            applicants: this.applicants.getApplicants(),
            creditCheck: this.state.creditCheck,
            hasBeenAtViewing: this.state.hasBeenAtViewing,
        }
    }
    setSelectedOption(name, option) {
        this.setState({ [name]: option });
    }
    render() {
        const {hideHeaders, color} = this.props;
        const selectedOccupation = this.state.occupation && this.state.occupation.value;
        const selectedMaritalStatus = this.state.maritalStatus && this.state.maritalStatus.value;
        const selectedDeposit = this.state.deposit && this.state.deposit.value;
        const selectedPets = this.state.pets && this.state.pets.value;
        const selectedSmoke = this.state.smoke && this.state.smoke.value;
        const selectedRentalAddress = this.state.rentalAddress && this.state.rentalAddress.value;
        const selectedExistingContract = this.state.existingContract && this.state.existingContract.value;
        const hasBeenAtViewing = this.state.hasBeenAtViewing && this.state.hasBeenAtViewing.value;

        return (
            <div className={`forms__inputContainer forms__inputContainer--${color}`}>
                {!hideHeaders && <h2 className="forms__formHeader">Boligsøknad</h2>}
                <div className="forms__formElement">
                    <Input name="identityNumber" type="text" placeholder="Fødselsnummer 11 siffer" ref={(identityNumber) => this.identityNumber = identityNumber} validations="minLength:11" required/>
                </div>
                <div className="forms__formElement">
                    <Input name="currentAddress" type="text" placeholder="Nåværende adresse" ref={(currentAddress) => this.currentAddress = currentAddress} validations="minLength:1" required/>
                </div>
                <div className="forms__formElement">
                    <Input name="currentZip" type="text" placeholder="Nåværende postnummer" ref={(currentZip) => this.currentZip = currentZip} validations="minLength:4" required/>
                </div>
                <div className="forms__formElement">
                    <Input name="currentCity" type="text" placeholder="Nåværende poststed" ref={(currentCity) => this.currentCity = currentCity} validations="minLength:1" required/>
                </div>
                <div className="forms__formElement">
                    <SelectComponent validations="isExisty" value={selectedExistingContract} onChange={(option) => this.setSelectedOption('existingContract', option)} name="existingContract" options={existingContractOptions} className="react-select-custom" placeholder="Gjelder dette transport av nåværende kontrakt?"/>
                </div>
                <div className="forms__formElement">
                    <SelectComponent validations="isExisty" value={selectedRentalAddress} onChange={(option) => this.setSelectedOption('rentalAddress', option)} name="rentalAddress" options={rentalAddressOptions} className="react-select-custom" placeholder="Ønsket utleieadresse / Referanse"/>
                </div>
                <div className="forms__formElement">
                    <SelectComponent validations="isExisty" value={hasBeenAtViewing} onChange={(option) => this.setSelectedOption('hasBeenAtViewing', option)} name="hasBeenAtViewing" options={viewingOptions} className="react-select-custom" placeholder="Har du vært på visning?"/>
                </div>
                <div className="forms__formElement">
                    <SelectComponent validations="isExisty" value={selectedMaritalStatus} onChange={(option) => this.setSelectedOption('maritalStatus', option)} name="maritalStatus" options={maritalStatusOptions} className="react-select-custom" placeholder="Sivilstand"/>
                </div>
                <div className="forms__formElement">
                    <SelectComponent validations="isExisty" value={selectedOccupation} onChange={(option) => this.setSelectedOption('occupation', option)} name="occupation" options={occupationOptions} className="react-select-custom" placeholder="Arbeid/Student"/>
                </div>
                <div className="forms__formElement">
                    <SelectComponent validations="isExisty" value={selectedDeposit} onChange={(option) => this.setSelectedOption('deposit', option)} name="deposit" options={depositOptions} className="react-select-custom" placeholder="Depositum"/>
                </div>
                <div className="forms__formElement">
                    <SelectComponent validations="isExisty" value={selectedPets} onChange={(option) => this.setSelectedOption('pets', option)} name="pets" options={petsOptions} className="react-select-custom" placeholder="Husdyr"/>
                </div>
                <div className="forms__formElement">
                    <SelectComponent validations="isExisty" value={selectedSmoke} onChange={(option) => this.setSelectedOption('smoke', option)} name="smoke" options={smokeOptions} className="react-select-custom" placeholder="Røyker"/>
                </div>
                <div className="forms__formElement">
                    <Input name="numPeople" type="text" placeholder="Antall voksne og barn som skal bo i leiligheten" ref={(numPeople) => this.numPeople = numPeople} required/>
                </div>
                <div className="forms__formElement">
                    <Input required name="reference" type="text" placeholder="Referanse / Navn og telefon tidligere utleier" ref={(reference) => this.reference = reference}/>
                </div>
                <div className="forms__formElement">
                    <Input required name="finn" type="text" placeholder="Finn-kode/lenke" ref={(finn) => this.finn = finn}/>
                </div>
                <div className="forms__formElement">
                    <Input required name="rentFrom" type="text" placeholder="Ønsker å leie fra" ref={(rentFrom) => this.rentFrom = rentFrom}/>
                </div>
                <div className="forms__formElement">
                    <label className="form-label">Litt om meg/oss</label>
                    <textarea placeholder="Litt om meg/oss" ref={(bio) => this.bio = bio}/>
                </div>
                <div className="forms__formElement">
                    <label><input required type="checkbox" value={true} onChange={ev => this.setState({ creditCheck: ev.target.checked })}/> Jeg samtykker til kredittsjekk</label>
                </div>
                <div className="forms__sokere">
                    <Soker color={color} ref={(applicants) => this.applicants = applicants}/>
                </div>
            </div>
        )
    }
}

module.exports = BoligSoknad;



// WEBPACK FOOTER //
// ./src/main/resources/site/parts/Forms/forms/BoligSoknad/index.jsx